var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-right",class:{ 'hidden': _vm.hidden }},[_c('div',{staticClass:"viewer-action-details",attrs:{"id":"viewer-action-details"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }